module.exports = __webpack_public_path__ + "86bee063006e3f15f2192ffee347210b.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/user/request-center/approvals/approvals.html
// module id = 2616
// module chunks = 0